// 手机号管理 短信模板

import axios from '@/util/request'

//
export function getPhoneList (data) {
  let url = '/api/v1/phone/get_phone_list/'
  return axios.post(url, data)
}

export function addPhone (data) {
  let url = '/api/v1/phone/add_phone/'
  return axios.post(url, data)
}

//
export function updatePhone (data) {
  let url = '/api/v1/phone/update_phone/'
  return axios.post(url, data)
}

//
export function deletePhone (data) {
  let url = '/api/v1/phone/delete_phone/'
  return axios.post(url, data)
}

export function getSMSTemplate (data) {
  let url = '/api/v1/phone/get_sms_template/'
  return axios.post(url, data)
}

export function updateSMSTemplate (data) {
  let url = '/api/v1/phone/update_sms_template/'
  return axios.post(url, data)
}
